import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { FREQUENT_INTERVAL_THRESHOLD } from './ScrollableContent.constants';
export function hasHorizontalScrollbar(ref) {
  if (ref.current) {
    return ref.current.scrollWidth > ref.current.clientWidth;
  }
  return false;
}
export function hasReachedHorizontalStart(ref) {
  if (ref.current) {
    return ref.current.scrollLeft === 0;
  }
  return false;
}
export function hasReachedHorizontalEnd(ref) {
  if (ref.current) {
    return ref.current.scrollLeft + ref.current.clientWidth === ref.current.scrollWidth;
  }
  return false;
}
export function ifScrollIntervalTooFrequent(intervalFactor) {
  return intervalFactor < FREQUENT_INTERVAL_THRESHOLD;
}
export function getSnapScrollDistance(ref) {
  if (!ref.current) {
    return 0;
  }
  var children = _get(ref, 'current.children', []);
  if (_isEmpty(children)) {
    return 0;
  }
  var totalWidth = Array.from(children).reduce(function (acc, child) {
    return acc + _get(child, 'clientWidth', 0);
  }, 0);
  return totalWidth / children.length;
}